import { Environment } from "../../environments/Environment";
import { axiosInstance } from "../interceptor/useAxiosInterceptors";

export const SaveProjectTaskConfig = async (payload) => {
    try {
        const response = await axiosInstance.post(
            `${Environment.emsUrl}/project-task-config/save`,
            payload
        );
        return response.data;
    } catch (error) {
        console.error("Error saving project task config:", error);
        throw error;
    }
};

export const GetTasksByProjectCode = async (projectCode) => {
    try {
        const response = await axiosInstance.get(
            `${Environment.emsUrl}/project-task-config/${projectCode}`
        );
        return response.data;
    } catch (error) {
        console.error(`Error fetching tasks for project code (${projectCode}):`, error);
        throw error;
    }
};

export const DeleteProjectTaskConfig = async (projectCode) => {
    try {
        const response = await axiosInstance.delete(
            `${Environment.emsUrl}/project-task-config/${projectCode}`
        );
        return response.data;
    } catch (error) {
        console.error(`Error deleting project task config for code (${projectCode}):`, error);
        throw error;
    }
};

export const GetAllProjectTaskConfigs = async (page = 0, size = 10) => {
    try {
        const response = await axiosInstance.get(
            `${Environment.emsUrl}/project-task-config/all`,
            {
                params: { page, size }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching all project task configs:", error);
        throw error;
    }
};
